import { SVGProps } from 'react';

const BellElectric = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.518 17.347A7 7 0 0 1 14 19m4.8-15A11 11 0 0 1 20 9M9 9h.01M22 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-6-7A7 7 0 1 1 2 9a7 7 0 0 1 14 0M6 16h6a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2"
    />
  </svg>
);
export default BellElectric;
